import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { useStationStyle } from "../styles/index.styles";
import AvatarHiplade from "../../common/components/avatarhiplade";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";

export default function ItemAppraiser({
  appraisers = [],
  appraisers_id = [],
  setAppraisers_id,
}: any) {
  const styles = useStationStyle();
  const { t } = useTranslation();
  const [localAppraisers, setLocalAppraisers] = useState<any[]>(Array.isArray(appraisers) ? appraisers : []);

  useEffect(() => {
    setLocalAppraisers(Array.isArray(appraisers) ? appraisers : []);
  }, [appraisers]);

  const removeAppraiser = (idToRemove: number) => {
    const newAppraisers = localAppraisers.filter((appraiser: any) => appraiser.id !== idToRemove);
    setLocalAppraisers(newAppraisers);
    setAppraisers_id(newAppraisers.map((a: any) => a.id));
  };

  if (!localAppraisers || localAppraisers.length === 0) {
    return (
      <Box className={styles.item}>
        <Box className={styles.itemName}>{t("empty_appraiser")}</Box>
      </Box>
    );
  }

  return (
    <Box>
      {localAppraisers.map((appraiser: any) => (
        <Box
          className={styles.item}
          key={appraiser.id}
          sx={{
            backgroundColor: appraiser.role_string === 'student' ? '#fae6ffff' : '#fff',
          }}

        >
          <Box className={styles.itemName}>
            <AvatarHiplade
              nameUser={appraiser?.name}
              size="mini"
              id={appraiser?.id}
            />
            {appraiser?.name}
          </Box>
          <Box>
              <CloseIcon
                className={styles.close}
                onClick={() => removeAppraiser(appraiser.id)}
              />
          </Box>
        </Box>
      ))}
    </Box>
  );
}
